import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { EASE } from "./Reveal";

export const CASE_TABS = [
  {
    id: "business",
    label: "THE BUSINESS",
    text: "College admissions, standardized testing and financial-aid strategy are complicated services involving many different decisions.",
  },
  {
    id: "challenge",
    label: "THE CHALLENGE",
    text: "A parent doesn't need to understand every technical detail immediately. They need to quickly understand: What does DTCC help us accomplish? Why should we trust them? What evidence supports their expertise? What do we do next?",
  },
  {
    id: "story",
    label: "THE STORY",
    big: "Get In. Score Higher. Pay Less.",
    text: "Three ideas that compress a complicated service offering into an understandable customer journey.",
  },
  {
    id: "experience",
    label: "THE EXPERIENCE",
    text: "The website expands that story through services, results, social proof, case studies, expertise — and a clear path to consultation.",
  },
  {
    id: "result",
    label: "THE RESULT",
    big: "Complex business. Clear story. Digital experience.",
    text: "A premium digital presence families can understand, trust and act on.",
  },
];

export default function CaseStudyTabs() {
  const [active, setActive] = useState(CASE_TABS[0].id);
  const current = CASE_TABS.find((t) => t.id === active);

  return (
    <div data-testid="case-study-tabs">
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Case study breakdown">
        {CASE_TABS.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={active === t.id}
            data-testid={`case-tab-${t.id}`}
            onClick={() => setActive(t.id)}
            className={`rounded-full border px-4 py-2 font-mono text-[10px] font-semibold tracking-[0.16em] transition-colors duration-200 ${
              active === t.id
                ? "border-gold bg-gold/10 text-gold"
                : "border-navyline text-slate-500 hover:border-gold/40 hover:text-slate-300"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="relative mt-6 min-h-[150px] rounded-2xl border border-navyline bg-ink/50 p-6 sm:p-7">
        <AnimatePresence mode="wait">
          <motion.div
            key={current.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.25, ease: EASE }}
          >
            <p className="font-mono text-[11px] font-semibold tracking-[0.24em] text-gold">{current.label}</p>
            {current.big && (
              <p data-testid="case-tab-big" className="mt-3 font-display text-2xl font-bold leading-snug text-white sm:text-3xl">
                {current.big}
              </p>
            )}
            <p data-testid="case-tab-content" className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
              {current.text}
            </p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
